import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import { CommercialPictureAnalysisList } from "@/features/commercialPictureAnalysis/routes/CommercialPictureAnalysisList";
import { CommercialPictureAnalysisDetail } from "@/features/commercialPictureAnalysis/routes/CommercialPictureAnalysisDetail";
import { CommercialPictureAnalysisPDFUpload } from "@/features/commercialPictureAnalysis/routes/CommercialPictureAnalysisPDFUpload";

// フラグによる出し分けは App.tsx 側で行うため、ここでは分岐せずルートを列挙する
export const CommercialPictureAnalysisRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<Navigate to="list" />} />
      <Route path="list" element={<CommercialPictureAnalysisList />} />
      <Route path="detail/:id" element={<CommercialPictureAnalysisDetail />} />
      <Route path="upload" element={<CommercialPictureAnalysisPDFUpload />} />
      <Route path="*" element={<Navigate to="list" />} />
    </Routes>
  );
};
